module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAMCAYAAACulacQAAAAdUlEQVQoU2NUUTk9+c4dkwIGBsa/DGiAUVX1zP///xl2fvvGEPTsmck3ZHmwJEjg/3+Gs0xMLP63bhk8hSmAS0IFnv77x+h/967xWRAfXRJkwjcGBsagO3eMd2JIQqz4//f/f4YC0iTxGYvdQTi9gjMQ8AUfAAzSXwf9GFRRAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/home/tinified/swiperselect.png
// module id = w+yE
// module chunks = 1